import { render, staticRenderFns } from "./KeyTaxRateWord.vue?vue&type=template&id=8b2d32bc&scoped=true"
import script from "./KeyTaxRateWord.vue?vue&type=script&lang=js"
export * from "./KeyTaxRateWord.vue?vue&type=script&lang=js"
import style0 from "./KeyTaxRateWord.vue?vue&type=style&index=0&id=8b2d32bc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2d32bc",
  null
  
)

export default component.exports